module.exports = __webpack_public_path__ + "img/e2.7b4afa1d.png";